import {
  Backdrop,
  Button,
  Container,
  IconButton,
  Logo,
  Spacer,
  SvgClose,
  Text,
} from '@loomhq/lens';
import React from 'react';

import { showErrorBar } from 'actions/errorBar';
import { updateWorkspaceDetails } from 'actions/workspace';
import { ERROR } from 'constants/error-severities';
import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';

import markOnboardingCardAsDismissed from './MarkOnboardingCardAsDismissed.graphql';

import styles from './styles.module.less';

const WelcomeModal = ({
  isOpen,
  title,
  subtitle,
  buttonText,
  onButtonClick,
  onDismissClick,
  dismissAltText,
  dismissText,
  onDismissTextClick,
}) => {
  return (
    <Backdrop isOpen={isOpen}>
      <section
        className={`theme-dark ${styles.dashboardOnboardingWelcomeContainer}`}
      >
        <Container
          padding={{ default: 3, small: 7 }}
          radius="medium"
          shadow="large"
          htmlTag="article"
          maxWidth="27rem"
          className="relative"
          backgroundColor="grey7"
        >
          {onDismissClick && (
            <IconButton
              size="small"
              icon={<SvgClose />}
              onClick={onDismissClick}
              altText={dismissAltText || 'Dismiss'}
              className="dashboardOnboardingWelcomeClose"
            />
          )}
          <Logo variant="symbol" maxWidth={8} />
          <Spacer top={2} />
          <Text size="xlarge" fontWeight="black" htmlTag="h3">
            {title}
          </Text>
          <Spacer top="medium" />
          <Text size="large" fontWeight="book" htmlTag="p">
            {subtitle}
          </Text>
          <Spacer top={4} />
          <Button
            variant="primary"
            size="large"
            hasFullWidth
            onClick={onButtonClick}
          >
            {buttonText}
          </Button>
          {dismissText && (
            <div className={styles.dismissText}>
              <Spacer top={2} />
              <Text
                onClick={onDismissTextClick}
                fontWeight="book"
                alignment="center"
              >
                {dismissText}
              </Text>
            </div>
          )}
        </Container>
      </section>
    </Backdrop>
  );
};

export const dismissElementHandler = async (dispatch, cardKey, workspaceId) => {
  if (!cardKey || !dispatch) {
    return;
  }

  const gqlClient = getGraphQLClient();

  try {
    const { data } = await gqlClient.mutate({
      mutation: markOnboardingCardAsDismissed,
      variables: {
        cardKey,
        workspaceId,
      },
    });

    const { onboarding } = data;

    dispatch(
      updateWorkspaceDetails({
        id: workspaceId,
        onboarding,
      })
    );
  } catch (err) {
    dispatch(showErrorBar(ERROR, 'Oops! Failed to dismisss onboarding card.'));

    sentry.logException(err, 'Error dismissing workplace onboarding card');
  }
};

export default WelcomeModal;
